'use client';

import { TabGroup, TabList } from '@headlessui/react';
import Image from 'next/image';
import { useGetApiBackOfficeUsersCurrentUserDetail } from '@/api/backoffice/back-office-users/back-office-users';
import { useAuthDialog } from '@/context/AuthDialogProvider';
import { Button } from '../button';

export const PickemsHowToPlaySection = () => {
  const { toggleIsOpen } = useAuthDialog();

  const { data, isLoading } = useGetApiBackOfficeUsersCurrentUserDetail({
    query: {
      refetchOnWindowFocus: true,
      refetchOnMount: true,
    },
  });

  const tabs = [
    'Create free account',
    'Choose your esports and teams',
    'Enter special tournaments',
  ];

  const basepath = '/assets/';

  if (isLoading) {
    return null;
  }

  return (
    <div>
      <h2 className="mb-4 font-semibold text-2xl">How to Play</h2>
      <p className="mb-6 text-sm">
        All you need is some esports knowledge and a{' '}
        <span className="text-blue-gray">free GOCORE account.</span>
      </p>
      <TabGroup className="w-full">
        <TabList className="mb-4 flex w-full max-w-full space-x-4 overflow-x-auto pb-2 pl-2 md:space-x-8 md:pl-3">
          {tabs.map((tab) => (
            <div
              className="md:-skew-x-6 flex w-40 shrink-0 transform items-center justify-center rounded-lg border border-light-blue-o50 px-4 py-4 transition-transform md:w-56 md:px-8 md:py-6 lg:w-48"
              key={tab}
            >
              <h3 className="transform text-center font-semibold text-base md:skew-x-6 md:text-lg">
                {tab}
              </h3>
            </div>
          ))}
        </TabList>
        <div className="md:-skew-x-3 grid w-full transform items-center justify-center gap-4 rounded-lg border border-light-blue-o50 bg-dark-gray p-4 px-4 md:gap-8 md:p-8 md:px-6 lg:grid-cols-[1fr_2fr] lg:px-10">
          <Image
            alt="Create free account"
            className="mt-auto w-full rounded-lg shadow-md md:max-w-[306px]"
            height={250}
            src={`${basepath}register.png`}
            width={358}
          />

          <div className="flex transform flex-col items-start gap-4 text-left md:max-w-md md:skew-x-3 md:gap-5">
            <p className="text-sm md:text-base">
              Register in just a few clicks and dive into the action—our quick
              and easy sign-up process ensures you&apos;re ready to play and
              make your picks in no time!
            </p>
            {!data && (
              <Button
                className="w-full md:w-auto"
                onClick={() => toggleIsOpen('sign-up')}
                size="lg"
                variant="primary"
              >
                Create Account
              </Button>
            )}
          </div>
        </div>
      </TabGroup>
    </div>
  );
};
